var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { siteIDs } from '../../../adapters/utils';
export var getContextWithoutPagination = function (context) {
    var _a = context, _b = siteIDs.TOTAL_PAGE_COUNT, _ = _a[_b], _c = siteIDs.CURRENT_PAGE_NUMBER, _2 = _a[_c], _d = siteIDs.PREV, _3 = _a[_d], _e = siteIDs.NEXT, _4 = _a[_e], dataWithoutPagination = __rest(_a, [typeof _b === "symbol" ? _b : _b + "", typeof _c === "symbol" ? _c : _c + "", typeof _d === "symbol" ? _d : _d + "", typeof _e === "symbol" ? _e : _e + ""]);
    return dataWithoutPagination;
};
